import { request } from './http';

export async function getComplianceTemplates(filters = {}) {
    const queryParams = new URLSearchParams();
    if (filters.companyId != null && filters.companyId !== '') {
      queryParams.append('companyId', filters.companyId);
    }
    if (filters.facilityId != null && filters.facilityId !== '') {
      queryParams.append('facilityId', filters.facilityId);
    }
    const qs = queryParams.toString();
    return request(`/templates/compliance${qs ? `?${qs}` : ''}`);
  }

export async function getComplianceTemplate(id) {
    return request(`/templates/compliance/${id}`);
  }

export async function createComplianceTemplate(data) {
    return request('/templates/compliance', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function updateComplianceTemplate(id, data) {
    return request(`/templates/compliance/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

export async function deleteComplianceTemplate(id) {
    return request(`/templates/compliance/${id}`, {
      method: 'DELETE',
    });
  }

export async function getRaciTemplates(filters = {}) {
    const queryParams = new URLSearchParams();
    if (filters.companyId != null && filters.companyId !== '') {
      queryParams.append('companyId', filters.companyId);
    }
    if (filters.facilityId != null && filters.facilityId !== '') {
      queryParams.append('facilityId', filters.facilityId);
    }
    const qs = queryParams.toString();
    return request(`/templates/raci${qs ? `?${qs}` : ''}`);
  }

export async function getRaciTemplate(id) {
    return request(`/templates/raci/${id}`);
  }

export async function createRaciTemplate(data) {
    return request('/templates/raci', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function updateRaciTemplate(id, data) {
    return request(`/templates/raci/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

export async function deleteRaciTemplate(id) {
    return request(`/templates/raci/${id}`, {
      method: 'DELETE',
    });
  }

export const templatesApi = {
  getComplianceTemplates,
  getComplianceTemplate,
  createComplianceTemplate,
  updateComplianceTemplate,
  deleteComplianceTemplate,
  getRaciTemplates,
  getRaciTemplate,
  createRaciTemplate,
  updateRaciTemplate,
  deleteRaciTemplate,
};

